var ns = {
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = ns;


// WEBPACK FOOTER //
// ./~/tiny-svg/lib/util/ns.js